import { ServerResponse } from './serverResponse';
import { UserProfile } from './userProfile';

export class User extends ServerResponse {
  public id: number;
  public first_name: string;
  public last_name: string;
  public full_name: string;
  public username: string;
  public password: string;
  public user_profile: UserProfile;
  public status: string;
  public date_joined: string;
  public token: string;
  public experiences: any[];
  public educations: any[];
  public repeat_password: string;
  public email: string;
  public last_seen_at?: string;

  // front
  public passwordConfirm: string;
  public passwordCheck: string;

  constructor(first_name: string, last_name: string, username: string) {
    super();
    this.first_name = first_name;
    this.last_name = last_name;
    this.username = username;
  }
}
